import ClubDate, { FORMATS } from 'helpers/ClubDate';
import { LIBERATION_TYPES } from 'helpers/Dripping';

import SchedulerService from './SchedulerService';

export const SELECTOR = 'SELECTOR';
export const BY_DAYS_SELECTOR = 'BY_DAYS_SELECTOR';
export const BY_DATE_SELECTOR = 'BY_DATE_SELECTOR';
export const CUSTOM_DAYS_SELECTOR = 'CUSTOM_DAYS_SELECTOR';
export const REMOVE_DRIPPING_SELECTOR = 'REMOVE_DRIPPING_SELECTOR';
export const MASS_ACTION_SELECTOR = 'MASS_ACTION_SELECTOR';
export const UNDEFINED = 'UNDEFINED';
export const DAYS = 'DAYS';
export const CUSTOM = 'CUSTOM';
export const PREVIOUS = 'previous';
export const BEGIN = 'begin';

export const SCHEDULER_OPTIONS = {
  [LIBERATION_TYPES.BY_DAYS]: {
    iconName: 'calendar-alt',
    title: 'dripping.days.title_new',
    tooltip: 'dripping.days.info',
    wizard: 'dripping.days.description_new',
    description: 'dripping.days.description_new',
    label: 'general.n_days',
    type: LIBERATION_TYPES.BY_DAYS,
    icon: true,
    selector: BY_DAYS_SELECTOR,
    value: (item) => ({
      days: item.liberationDays || 0,
      count: item.liberationDays
    }),
    request: SchedulerService.setDrippingByDays
  },
  [LIBERATION_TYPES.BY_DATE]: {
    iconName: 'calendar-day',
    title: 'dripping.date.title_new',
    tooltip: 'dripping.date.info',
    wizard: 'dripping.date.wizard_info_new',
    type: LIBERATION_TYPES.BY_DATE,
    icon: true,
    selector: BY_DATE_SELECTOR,
    value: (item) => {
      if (!item.liberationDate) {
        return null;
      }

      const date = new Date(item.liberationDate);

      return ClubDate.format(date, FORMATS.DDMMYY);
    }
  },
  [LIBERATION_TYPES.REMOVE_DRIPPING]: {
    iconName: 'calendar-times',
    title: 'dripping.remove_dripping.title_new',
    wizard: 'dripping.remove_dripping.description',
    type: LIBERATION_TYPES.REMOVE_DRIPPING,
    selector: REMOVE_DRIPPING_SELECTOR,
    modal: true
  },
  [LIBERATION_TYPES.EXPIRATION]: {
    iconName: 'alarm-exclamation',
    title: 'dripping.expiration.title',
    tooltip: 'dripping.expiration.info',
    wizard: 'dripping.expiration.wizard_info_new',
    description: 'dripping.expiration.wizardInfo',
    type: LIBERATION_TYPES.EXPIRATION,
    icon: true,
    selector: BY_DAYS_SELECTOR,
    label: 'general.n_days',
    request: SchedulerService.setExpiration,
    value: (item) => ({
      days: item.durationDays || 0,
      count: item.durationDays
    })
  }
};
